import { render, staticRenderFns } from "./SegmentCreate.vue?vue&type=template&id=997b6952&"
import script from "./SegmentCreate.vue?vue&type=script&lang=js&"
export * from "./SegmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports